export default __webpack_public_path__ + "static/media/screen_google_sheets_04.ac3e52c1.png";